/// <amd-module name="DistributedTask/Common/SignalR/SignalRHubProxies" />

import { jqueryShimmed } from "VSS/Features/SignalR/3rdParty/jquery.shimmed";

import { ISignalRHubProxy } from "VSS/Features/SignalR/HubProxies.types";

import { TaskAgent, TaskAgentJobRequest } from "DistributedTask/Client/Contracts/TaskAgent";


export interface IAgentHubServer {
    subscribe: (poolId: number, agentId: number) => Promise<void>;
    unsubscribe: (poolId: number, agentId: number) => Promise<void>;
}

export interface ITaskAgentPoolHubServer {
    subscribe: (poolId: number) => Promise<void>;
    unsubscribe: (poolId: number) => Promise<void>;
}

export interface IPoolHubServer {
    subscribe: (poolId: number) => Promise<void>;
    unsubscribe: (poolId: number) => Promise<void>;
}

export interface IPoolsHubServer {
    subscribe: () => Promise<void>;
    unsubscribe: () => Promise<void>;
}

export interface IAgentHubClient {
    notifyAgentRequestUpdated: (poolId: number, agentId: number, requestId: number) => void;
}

export interface ITaskAgentPoolHubClient {
    notifyAgentAdded: (poolId: number, agent: TaskAgent) => void;
    notifyAgentConnected: (poolId: number, agentId: number) => void;
    notifyAgentDeleted: (poolId: number, agentId: number) => void;
    notifyAgentDisconnected: (poolId: number, agentId: number) => void;
    notifyAgentRequestAssigned: (poolId: number, request: TaskAgentJobRequest) => void;
    notifyAgentRequestCompleted: (poolId: number, request: TaskAgentJobRequest) => void;
    notifyAgentRequestQueued: (poolId: number, request: TaskAgentJobRequest) => void;
    notifyAgentRequestStarted: (poolId: number, request: TaskAgentJobRequest) => void;
    notifyAgentUpdated: (poolId: number, agent: TaskAgent) => void;
}

export interface IPoolHubClient {
    notifyAgentAdded: (poolId: number, agentId: number) => void;
    notifyAgentConnected: (poolId: number, agentId: number) => void;
    notifyAgentDeleted: (poolId: number, agentId: number) => void;
    notifyAgentDisconnected: (poolId: number, agentId: number) => void;
    notifyAgentRequestAssigned: (poolId: number, requestId: number) => void;
    notifyAgentRequestCompleted: (poolId: number, requestId: number) => void;
    notifyAgentRequestQueued: (poolId: number, requestId: number) => void;
    notifyAgentRequestStarted: (poolId: number, requestId: number) => void;
    notifyAgentUpdated: (poolId: number, agentId: number) => void;
}

export interface IPoolsHubClient {
    notifyAgentRequestUpdated: (requestId: number, poolId: number) => void;
}

export namespace HubNames {
    export const agentHub = "agentHub";
    export const poolHub = "poolHub";
    export const poolsHub = "poolsHub";
    export const taskAgentPoolHub = "taskAgentPoolHub";
}

export function getDTProxyToRegister<C, S>(baseProxy: ISignalRHubProxy<any, any>): ISignalRHubProxy<C, S> {
    const $ = jqueryShimmed;
    baseProxy.server = {
        subscribe: function (poolId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["Subscribe"], $.makeArray(arguments)));
        },

        unsubscribe: function (poolId: number) {
            return baseProxy.invoke.apply(baseProxy, $.merge(["Unsubscribe"], $.makeArray(arguments)));
        }
    };

    return baseProxy;
}
